<template>
    <div id="app-layout" class="app">

        <div class="navbar-con">
            <nav class="navbar" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                    <router-link :to="{ name : $ROUTES.DASHBOARD }" class="navbar-item">
                        <img :src="$srcOverwrite(this.$store.state.dealer_portal.brandLogo)">
                    </router-link>

                    <a
                        role="button"
                        class="navbar-burger"
                        :class="{ 'is-active' : menu_open }"
                        aria-label="menu"
                        aria-expanded="false"
                        @click="toggleMenu"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>
                <div class="navbar-menu" :class="{ 'is-active' : menu_open }">
                    <div class="navbar-start">
                        <router-link :to="{ name : $ROUTES.DASHBOARD }" class="navbar-item">Dashboard</router-link>

                        <router-link :to="{ name : $ROUTES.ORDERS_INDEX }" class="navbar-item">Orders</router-link>

                        <router-link
                            v-if="showProducts"
                            :to="{ name : $ROUTES.PRODUCTS_INDEX }"
                            class="navbar-item"
                        >
                            Products
                        </router-link>
                        <router-link :to="{ name : $ROUTES.SETTINGS }" class="navbar-item">Settings</router-link>
                    </div>
                    <div class="navbar-end">
                        <div class="navbar-item has-dropdown" :class="{ 'is-active' : user_menu_open }" @click="toggleTopNavMenu()">
                            <a class="navbar-link">{{dealer.email}}</a>
                            <div class="navbar-dropdown">
                                <router-link :to="{ name : $ROUTES.ACCOUNT }" class="navbar-item">Manage Account</router-link>
                                <a class="navbar-item" @click="logout()">
                                    Logout
                                </a>
                            </div>
                        </div>
                        <div
                            v-if="showCheckout"
                            class="navbar-item"
                        >
                            <a class="navbar-item">
                                <router-link class="cart-con" :to="{ name : $ROUTES.CART }">
                                    <i class="fa fa-shopping-cart"></i>
                                    <div v-if="cartCount" class="bubble">
                                        {{cartCount}}
                                    </div>
                                </router-link>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

        <access-guard>
            <transition>
                <router-view></router-view>
            </transition>
        </access-guard>

    </div>
</template>

<script>
import AccessGuard from "../components/AccessGuard";
import AccountSettingsMixin from "../mixins/AccountSettingsMixin";
export default {
    name : 'AppLayout',
    components : {AccessGuard},
    mixins : [AccountSettingsMixin],
    data (){
        return {
            menu_open : false,
            user_menu_open : false,
        };
    },
    computed : {
        dealer () {
            return this.$getDealer() || {};
        },
        cartCount () {
            return this.$store.getters[this.$STORE_CONSTANTS.CART.TOTAL_QUANTITY];
        },
    },
    methods : {
        toggleMenu () {
            this.menu_open = !this.menu_open;
        },
        toggleTopNavMenu () {
            this.user_menu_open = !this.user_menu_open;
        },
        logout () {
            this.$store.commit('resetState');
            window.localStorage.removeItem('token');
            this.$store.commit('setSessionContext', null);
            this.$router.push({ name : 'login' });
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/css/_theme';
    .cart-con {
        position:relative;
        color:$grey-dark;
        .fa {
            font-size:28px;
        }
        $bubbleSize:21px;
        .bubble {
            text-align:center;
            position:absolute;
            font-size:12px;
            top:-8px;
            right:-8px;
            height: $bubbleSize;
            width:$bubbleSize;
            border-radius:$bubbleSize;
            background-color:$warning;
        }
    }
    .navbar-con {
        font-size:15px;
    }
</style>
